var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"primary","absolute":""}},[_c('div',{staticClass:"d-flex align-center",on:{"click":function () {
                this$1.$router.replace('/');
            }}},[_c('v-img',{attrs:{"src":require("@/assets/logo.png"),"height":"95%"}})],1),_c('v-spacer'),_c('div',{staticClass:"hidden-sm-and-down"},[_c('navbtns')],1),_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
            var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"hidden-md-and-up",attrs:{"text":"","light":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" fas fa-bars ")])],1)]}}])},[_c('navbtns')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }